import * as Sentry from "@sentry/react";

export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
  dsn: sentryDsn,
  sendDefaultPii: true,
  integrations: [],
});
